import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/ZidanCorson'
      className='link footer__link'
    >
      Created By Zidan Wang
    </a>
  </footer>
)

export default Footer
